import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetOffersFromRecommendedApiLoading, EGetOffersFromRecommendedApiActionType } from './types';

export const getOffersFromRecommendedApiLoading: () => TGetOffersFromRecommendedApiLoading =
  actionGenerator<EGetOffersFromRecommendedApiActionType.Loading>(EGetOffersFromRecommendedApiActionType.Loading);
